module.exports = __webpack_public_path__ + "img/01宋雷.52a11b7b.png";